import React, { Component } from 'react'
import {MainSidebar} from "reactjs-admin-lte";

function createLink(route, selectedRoute) {
    const {name, path, icon} = route;
    const active = (selectedRoute === path);
    return <MainSidebar.Menu.Item
        active={active}
        href={path}
        iconName={icon}
        key={path}
        title={name}>
    </MainSidebar.Menu.Item>;
}

class NavigationSidebar extends Component {
    static defaultProps = {
        routes: [],
        selectedRoute: ""
    };

    render() {
        const { routes, selectedRoute } =  this.props;
        const origin = window.location.protocol + '//' + window.location.host
        return (
            <MainSidebar>
                <MainSidebar.Menu>
                    <MainSidebar.Menu.Header>MAIN NAVIGATION</MainSidebar.Menu.Header>
                    { routes.map((route) => createLink(route, selectedRoute)) }
                    <label style={{color: 'blue', paddingLeft:'35px', paddingTop:'40px'}}> <u><a style={{color: 'blue'}} href={origin + '/trp/auth/termsAndConditions'}>Terms and conditions </a></u></label>
                </MainSidebar.Menu>

            </MainSidebar>

        );
    }
}

export default NavigationSidebar
